export class LightGallery {
    constructor() {
        this.init();
    }

    init() {
        $( '.light-gallery' ).lightGallery( {
            loop: false,
            hideControlOnEnd: true,
            download: false,
            animateThumb: false,
            zoomFromOrigin: false,
            allowMediaOverlap: true,
            toggleThumb: true
        } );
    }
}
